import useTheme from 'branding/theme';
const useComponentPadding = ({ padding, paddingHorizontal, paddingVertical, paddingTop, paddingBottom, paddingLeft, paddingRight }) => {
    const { sizing: { component: componentSizing } } = useTheme();
    return {
        ...(padding && { padding: componentSizing.padding[padding] }),
        ...(paddingHorizontal && {
            paddingLeft: componentSizing.padding[paddingHorizontal],
            paddingRight: componentSizing.padding[paddingHorizontal]
        }),
        ...(paddingVertical && {
            paddingTop: componentSizing.padding[paddingVertical],
            paddingBottom: componentSizing.padding[paddingVertical]
        }),
        ...(paddingTop && { paddingTop: componentSizing.padding[paddingTop] }),
        ...(paddingBottom && { paddingBottom: componentSizing.padding[paddingBottom] }),
        ...(paddingLeft && { paddingLeft: componentSizing.padding[paddingLeft] }),
        ...(paddingRight && { paddingRight: componentSizing.padding[paddingRight] })
    };
};
export default useComponentPadding;
//# sourceMappingURL=index.js.map